import {
  makePost,
  makeDelete,
  makePut,
  makeGetWithParam
} from './ServiceManager';

export const getPackages = async (activePage = 1, createdBy = null) => {
  const result = await makeGetWithParam(
    'service/package/packages',
    null,
    createdBy
      ? `?activePage=${activePage}&created_by=${encodeURIComponent(createdBy)}`
      : activePage
  );
  return result;
};

export const getPackagesWithName = async (
  activePage,
  name = null,
  createdBy
) => {
  const result = await makeGetWithParam(
    'service/package/packages',
    null,
    `?activePage=${activePage}&name=${name}${
      createdBy ? `&created_by=${encodeURIComponent(createdBy)}` : ''
    }`
  );
  return result;
};

export const insertPackage = async (packageData) => {
  const result = await makePost('service/package/package', { packageData });
  return result;
};

export const getPackage = async (id) => {
  const result = await makeGetWithParam('service/package/package', null, id);
  return result;
};

export const deletePackage = async (id) => {
  const result = await makeDelete('service/package/package', { id });
  return result;
};

export const updatePackage = async (packageData) => {
  const result = await makePut('service/package/package', { packageData });
  return result;
};



// WEBPACK FOOTER //
// ./src/services/PackageServiceManager.js